import { ComplianceCalendarEvent } from 'mapistry-shared';
import React from 'react';
import { VisuallyHidden } from '@monorepo/shared/componentsV2/VisuallyHidden';
import { CalendarEvent } from '../CalendarEvent';
import { CalendarEventTooltip } from '../CalendarEventTooltip';
import { getEventLinkProps } from '../helpers/complianceCalendarHelpers';
import {
  StyledSkeleton,
  EmptySectionParagraph,
  WeekViewEventLink,
} from '../styled';

export function WeekViewSectionContent({
  emptyMessage,
  events,
  isLoading,
  navigateToEventUrl,
}: {
  emptyMessage: string;
  events: ComplianceCalendarEvent[];
  isLoading: boolean;
  navigateToEventUrl: (url: string) => void;
}) {
  if (isLoading) {
    return (
      <>
        <VisuallyHidden>Loading events...</VisuallyHidden>
        <StyledSkeleton variant="rect" />
        <StyledSkeleton variant="rect" />
      </>
    );
  }

  if (events.length === 0) {
    return <EmptySectionParagraph>{emptyMessage}</EmptySectionParagraph>;
  }

  return (
    <>
      {events.map((event) => (
        <CalendarEventTooltip key={event.id} event={event}>
          {(titleRef) => (
            <WeekViewEventLink
              {...getEventLinkProps(event, navigateToEventUrl)}
            >
              <CalendarEvent
                status={event.status}
                title={event.title}
                titleRef={titleRef}
                truncation="vertical"
                linesBeforeTruncated={3}
              />
            </WeekViewEventLink>
          )}
        </CalendarEventTooltip>
      ))}
    </>
  );
}
